import { Col } from 'antd';
import { fieldSortOptions } from './FieldSortOptions';
import React from 'react';
import { SortByOption } from '@sonar-software/sonar-ts-types';

import {
	ApiCodeToggle,
	ApiCodeToggleQueryParams,
	SearchFilter,
	SearchFilterContainer,
	SearchFilterQueryParams,
	SortByFilter,
	SortByFilterQueryParams,
	TagFilter,
	TagFilterQueryParams
} from '../filters';
import { UpdateQueryParams, useSonarObjectReference } from '@hooks';

export type PeriscopeFieldSearchQueryParams = ApiCodeToggleQueryParams &
	SearchFilterQueryParams &
	SortByFilterQueryParams &
	TagFilterQueryParams;

export interface PeriscopeFieldSearchProps {
	onChange: UpdateQueryParams<PeriscopeFieldSearchQueryParams>;
	queryParams: PeriscopeFieldSearchQueryParams;
	sonarObjectId?: number;
}

export const PeriscopeFieldSearch: React.FC<PeriscopeFieldSearchProps> = ({
	onChange,
	queryParams,
	sonarObjectId
}) => {
	const showPopulation = useSonarObjectReference(sonarObjectId ?? 0)?.hasFieldSpyMetadata;

	const sortOptions = sonarObjectId && showPopulation !== undefined ?
		fieldSortOptions.map((option) =>
			(option.key === 'populationPercentage' ?
				{
				    ...option,
				    disabled: !showPopulation
				} :
				option)) :
		fieldSortOptions;

	return (
		<SearchFilterContainer>
			<Col span={ 12 }>
				<SearchFilter onChange={ onChange } />
			</Col>
			<Col
				className='align-right'
				span={ 12 }>
				<ApiCodeToggle
					checked={ Boolean(queryParams.useInternal) }
					onChange={ onChange } />
			</Col>
			<Col span={ 12 }>
				<TagFilter onChange={ onChange } />
			</Col>
			<Col
				className='align-right'
				span={ 12 }>
				<SortByFilter
					defaultSortOption={ fieldSortOptions[ 1 ] }
					onChange={ onChange }
					options={ sortOptions }
					queryParams={ queryParams } />
			</Col>
		</SearchFilterContainer>);
};
